import { Dispatch } from 'react-redux';

import { StoreState } from '../../../reducers';
import { Action } from '../../../actions';
import { createNotification } from '../../NotificationBar/actions';
import { updateDriveItem } from '../../DriveItemList/actions';
import { getData } from './sources';
import { SettingsActionKeys } from './settings';
import { getClientAndResourceIds } from '../utils/helpers';
import { Api } from '../../../typings/api';
import ApiUtils from '../../../utils/api';

export enum PreprodPublicationKeys {
	SET_DATA = '@@editor/preprodPublication/SET_DATA',
	SET_IS_UPDATING = '@@editor/preprodPublication/SET_IS_UPDATING'
}

interface PreprodPublicationData {
	tempGId?: number;
	lastUpdateDate?: number | string;
	urlWithPin?: string;
}

interface SetPreprodPublicationDataAction extends Action {
	type: PreprodPublicationKeys.SET_DATA;
	data: PreprodPublicationData;
}

interface SetIsUpdatingAction extends Action {
	type: PreprodPublicationKeys.SET_IS_UPDATING;
	isUpdating: boolean;
}

export type PreprodPublicationAction =
	SetPreprodPublicationDataAction |
	SetIsUpdatingAction;

export const setPreprodPublicationData = (data: PreprodPublicationData): SetPreprodPublicationDataAction => ({
	type: PreprodPublicationKeys.SET_DATA,
	data,
});

const setIsUpdating = (isUpdating: boolean): SetIsUpdatingAction => ({
	type: PreprodPublicationKeys.SET_IS_UPDATING,
	isUpdating,
});

export const updateOriginal = (tempGId: number, originalGId: number) => async (dispatch: Dispatch<StoreState>): Promise<void> => {
	try {
		dispatch(setIsUpdating(true));
		const { genericItemLastUpdate } = await ApiUtils.updateOriginalPublication(tempGId, originalGId);
		dispatch(setPreprodPublicationData({ lastUpdateDate: genericItemLastUpdate }));
	} catch (error) {
		dispatch(createNotification('error.update_publication'));
	} finally {
		dispatch(setIsUpdating(false));
	}
};

export const publish = (originalGId: number) => async (dispatch: Dispatch<StoreState>): Promise<void> => {
	try {
		dispatch(setIsUpdating(true));
		await ApiUtils.savePublicationSettings(originalGId, {
			accessType: Api.AssetItemAccessType.PUBLIC,
		});
		const resource = await ApiUtils.getMeta(originalGId);
		dispatch(updateDriveItem(resource));
		const { clientId } = getClientAndResourceIds();
		dispatch(getData(clientId, originalGId, true, false, true));
	} catch (error) {
		dispatch(createNotification('error.publish_publication'));
	} finally {
		dispatch(setIsUpdating(false));
	}
};

export const getPreprodPublicationUrl = (
	clientId: number,
	resourceId: number,
	label: string,
	forceUpdate?: boolean,
) => async (dispatch: Dispatch<StoreState>, getState: () => StoreState): Promise<void> => {
	try {
		const {
			editor: {
				preprodPublication: {
					urlWithPin,
				},
			},
		} = getState();

		if (!urlWithPin || forceUpdate) {
			const { resourceUrl } = await ApiUtils.sharePublication(clientId, resourceId, label);
			dispatch(setPreprodPublicationData({ urlWithPin: resourceUrl }));
		}
	} catch (error) {
		// no need for notification as it is called in background
	}
};

export const getPublishedPublicationUrl = (resourceId: number) => async (dispatch: Dispatch<StoreState>): Promise<void> => {
	try {
		const { projectUrl } = await ApiUtils.getPublicationIntegration(resourceId);
		dispatch({
			type: SettingsActionKeys.SET_SETTINGS,
			projectUrl,
		});
	} catch (error) {
		// no need for notification as it is called in background
	}
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/actions/preprodPublication.ts